import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import { CheckCircle, Category, Place, Build, Map, Task } from "@mui/icons-material";
import { cloneElement } from "react";
import { colors } from "../../../../../../ui/colors";

export const VerticalStepper = ({ steps, currentStep, onStepClick, onReset }) => {
  const activeStepIndex = steps.findIndex((s) => s.id === currentStep);
  const icons = [<Category />, <Place />, <Build />, <Map />, <Task />];

  const colorPrimary = colors.orange
  return (
    <Box
      sx={{
        ml: 5,
        justifyContent: "flex-start",
        width: 260,
        borderRadius: 3,
        backgroundcolorPrimary: "#fff",
        height: "fit-content",
      }}
    >
      <Stepper
        activeStep={activeStepIndex}
        orientation="vertical"
        sx={{
          "& .MuiStepConnector-line": {
            borderColor: colorPrimary[200],
            borderWidth: 2,
          },
        }}
      >
        {steps.map((step, index) => {
          const completed = index < activeStepIndex;
          const isActive = index === activeStepIndex;
          const icon =
            completed ? (
              <CheckCircle sx={{ fontSize: 18 }} />
            ) : (
              cloneElement(icons[index] || <Category />, { sx: { fontSize: 18 } })
            );

          return (
            <Step
              key={step.id}
              onClick={() => onStepClick?.(step.id)}
              sx={{
                cursor: "pointer",
                "&:hover .MuiStepLabel-label": {
                  color: colorPrimary.base,
                },
              }}
            >
              <Tooltip title={step.description || ""} arrow enterTouchDelay={500} leaveTouchDelay={3000}>
                <StepLabel
                  StepIconComponent={() => (
                    <Box
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: completed
                          ? colorPrimary[100]
                          : isActive
                          ? colorPrimary.base
                          : colors.gray[100],
                        color: completed
                          ? colorPrimary.base
                          : isActive
                          ? "#fff"
                          : colors.gray[400],
                        border: `2px solid ${
                          completed
                            ? colorPrimary[300]
                            : isActive
                            ? colorPrimary.base
                            : colors.gray[200]
                        }`,
                        transition: "all 0.2s ease",
                      }}
                    >
                      {icon}
                    </Box>
                  )}
                >
                  <Typography
                    variant="body2"
                    fontWeight={isActive || completed ? 600 : 400}
                    sx={{
                      color: isActive
                        ? colorPrimary.base
                        : completed
                        ? colors.gray[500]
                        : colors.gray[300],
                      ml: 1,
                    }}
                  >
                    {step.label}
                  </Typography>
                </StepLabel>
              </Tooltip>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};
